<template>
  <div class="fadeIn animated">
    <template v-if="status == 'total'">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>No</th>
          <th>Customer Name</th>
          <th>Address</th>
          <th>Activation Date</th>
          <th>Unregister Date</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(data,i) in detailCustomer">
          <td>{{i + 1}}</td>
          <td>{{data.cust_acc_name}}</td>
          <td>{{data.installation_address}}
            <br><strong>Register :</strong>{{data.cust_reg_date}}
          </td>
          <td>{{data.cust_activation_date}}</td>
          <td>{{data.cust_unreg_date | notShown}}</td>
        </tr>
        <template v-if="detailCustomer.length == 0">
          <tr class="alert alert-warning">
            <td colspan="5">
              {{noData}}
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </template>
    <template v-else-if="status == 'active'">
      <b-form-group>
        <b-form-checkbox-group
          v-model="selected"
          :options="options"
          switches
        ></b-form-checkbox-group>
      </b-form-group>
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>No</th>
          <th>Customer Name</th>
          <th>Address</th>
          <th>Activation Date</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(data,i) in selectData(detailCustomer, status, selected) "
            v-bind:class="data.close_on_periode? 'not-active': ''"
        >
          <td>{{i + 1}}</td>
          <td>{{data.cust_acc_name}}</td>
          <td>{{data.installation_address}}
            <br>
            <strong>Register: </strong>{{data.cust_reg_date}}
          </td>
          <td>{{data.cust_activation_date}}
            <template v-if="data.close_on_periode">
              <br>
              <span class="text-danger">
                <i class="fa fa-times"></i> Not Active
              </span>
            </template>
          </td>
        </tr>
        <template v-if="selectData(detailCustomer, status, selected).length == 0">
          <tr class="alert alert-warning">
            <td colspan="4">
              {{noData}}
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </template>
    <template v-else-if="status == 'non-active'">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>No</th>
          <th>Customer Name</th>
          <th>Address</th>
          <th>Unregister Date</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(data,i) in selectDataNonActive(detailCustomer) "
            v-bind:class="data.close_on_periode? 'not-active': ''">
          <td>{{i + 1}}</td>
          <td>{{data.cust_acc_name}}</td>
          <td>{{data.installation_address}}
            <br>
            <strong>Register:</strong> {{data.cust_reg_date}}</td>
          <td>{{data.cust_unreg_date}}</td>
        </tr>
        <template v-if="selectDataNonActive(detailCustomer).length == 0">
          <tr class="alert alert-warning">
            <td colspan="5">
              {{noData}}
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </template>
    <template v-else-if="status == 'activationperiode'">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>No</th>
          <th>Customer Name</th>
          <th>Address</th>
          <th>Activation Date </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(data,i) in selectDataActivationPeriode(detailCustomer) "
            v-bind:class="data.close_on_periode? 'not-active': ''"
        >
          <td>{{i + 1}}</td>
          <td>{{data.cust_acc_name}}</td>
          <td>{{data.installation_address}}
            <br>
            <strong>Register: </strong>{{data.cust_reg_date}}
          </td>
          <td>{{data.cust_activation_date}}
            <template v-if="data.close_on_periode">
              <br>
              <span class="text-danger">
                <i class="fa fa-times"></i> Not Active
              </span>
            </template>
          </td>
        </tr>
        <template v-if="selectDataActivationPeriode(detailCustomer).length == 0">
          <tr class="alert alert-warning">
            <td colspan="5">
              {{noData}}
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </template>
    <template v-else-if="status == 'closeInPeriode'">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>No</th>
          <th>Customer Name</th>
          <th>Address</th>
          <th>Unregister Date</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(data,i) in selectDataClose(detailCustomer)">
          <td>{{i + 1}}</td>
          <td>{{data.cust_acc_name}}</td>
          <td>{{data.installation_address}}
            <br>
            <strong>Register:</strong> {{data.cust_reg_date}}</td>
          <td>{{data.cust_unreg_date}}</td>
        </tr>
        <template v-if="selectDataClose(detailCustomer).length == 0">
          <tr class="alert alert-warning">
            <td colspan="5">
              {{noData}}
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </template>
  </div>
</template>
<script>
  export default {
    props: {
      status: {
        type: String,
        default: 'total'
      },
      dataAccount: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        detailCustomer: [],
        selected: ['0', '1'], // Must be an array reference!
        options: [
          {text: 'Active now', value: '0'},
          {text: 'Non-Active until in period', value: '1'}
        ],
        noData: 'No Data'
      }
    },
    async mounted() {
      this.detailCustomer = this.dataAccount
    },
    methods: {
      selectData(data, status, selected) {
        if (selected && status == 'active') {
          if (selected.length == 2) {
            return data.filter ((data) => data.active == true)
          } else if(selected[0] == '1') {
            return data.filter ((data) => {
              if (data.active == true && data.close_on_periode) {
                return true
               } else {
                return false
              }
            })
          } else if (selected[0] == '0') {
            return data.filter ((data) => {
              if (data.active == true && data.close_on_periode == false) {
                return true
              } else {
                return false
              }
            })
          } else if(selected.length == 0) {
            return []
          }
        }
      },
      selectDataNonActive(data) {
        return data.filter((data)=> {
          if(data.active == false ){
            return true
          }
          if(data.active == true && data.close_on_periode) {
            return true
          }
          return false
        })
      },
      selectDataActivationPeriode(data) {
          return data.filter((data) => {
            if (data.reg_on_periode) {
              return true
            }
            return false
          })
      },
      selectDataClose(data) {
        return data.filter(data => data.close_on_periode == true)
      }
    },
    filters: {
      notShown: function (date) {
        if (date == '0000-00-00') {
          return ''
        } else {
          return date
        }
      }
    }
  }
</script>
<style>
  .not-active{
    background-color: #efc3c2;
  }

</style>
